import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'

export const BedroomLayout = withFacetContext(
    FacetName.bedroom_layout,
    withFilterContext(FilterName.bedroom_layout, SearchFiltersDropdown, {
        hideLabel: true,
        title: 'Bedroom layout',
    })
)
